import * as React from 'react';
import '../Calendar.css';
import { isSameMonth } from 'date-fns';
import Day from './Month/Month';
import { BooksWithParsedDates } from '../Calendar';
import { Month as MonthType } from '../Calendar';
import Month from './Month/Month';

interface Props {
	months: MonthType[];
	openDate: Date;
}

const GroupOfMonths: React.FunctionComponent<Props> = props => {
	return <div className="week">
		{props.months.map((month, key) => {
			return <Month
				month={month}
				key={key}
				books={[]}
			/>
		})}
	</div>;
};

export default GroupOfMonths;
